export enum FeedbackType {
  HAS_OPENED = 'has_opened',
  HAS_CONFIRMED = 'has_confirmed',
  LIKES = 'likes',
  HAS_LOGGED = 'has_logged',
  HAS_ACCESSED = 'has_accessed',
}
